/**
 * Ksting
 *
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, { Component } from 'react';
import { bool } from 'prop-types';
import { Link } from 'react-router-dom';

import LanguageSwitch from './LanguageSwitch/LanguageSwitch';
import SiteLogo from 'components/SiteLogo/SiteLogo';

import styles from './footer.scss';

/**
 * This is the Footer component.
 *
 * @author Pelle Lundgren <pelle.lundgren@vntrs.com> and Rafael Santos <rafael.santos@vntrs.com>
 */
export default class Footer extends Component {
  /**
   * Declare expected prop types.
   *
   * @type {object}
   */
  static propTypes = {
    isAuth: bool,
  };

  /**
   * Render Footer.
   *
   * @return {Object}
   */

  render() {
    const { isAuth } = this.props;

    const date = new Date();
    const year = date.getFullYear();

    if (isAuth) return null;

    return (
      <footer className={styles.wrapper}>
        {/* Hidden until newsletter is connected */}
        {/* <article className={styles.newsletter}>
          <div className={styles.container}>
            <div className={styles.row}>
              <div className={styles.connected}>
                <div>
                  <h1 className={styles.title}>Let's stay connected!</h1>
                </div>
                <div className={styles.inputWrapper}>
                  <input type="text" placeholder={'Enter email'}></input>
                  <input type="button" value="Subscribe" />
                </div>
                <p>Sign up to receive our newsletters and exclusive offers.</p>
              </div>
            </div>
          </div>
        </article> */}
        <article className={styles.article}>
          <div className={styles.container}>
            <div className={styles.row}>
              <div className={styles.col}>
                <h1>ABOUT</h1>
                <ul className={styles.links}>
                  <li>
                    <Link to="/about-us">KSTING team</Link>
                  </li>
                  <li>
                    <Link to="/news">News</Link>
                  </li>
                  <li>
                    <Link to="/page/faq">FAQ</Link>
                  </li>
                  <li>
                    <Link to="/page/terms">Terms & Privacy</Link>
                  </li>
                </ul>
              </div>
              <div className={styles.col}>
                <h1>LOCATION</h1>
                <ul className={styles.links}>
                  <li>Grev Turegatan 10</li>
                  <li>114 46 Stockholm</li>
                  <li>Sweden</li>
                </ul>
              </div>
              <div className={styles.col}>
                <h1>CONTACT</h1>
                <ul className={styles.links}>
                  <li>
                    <a href="tel:+46735365917">+46 7 3536 5917</a>
                  </li>
                  <li>
                    <a href="mailto:info@ksting.com">info@ksting.com</a>
                  </li>
                  <li>
                    <a
                      href="https://www.instagram.com/kstingofficial/"
                      target="_blank" // eslint-disable-line
                      rel=""
                    >
                      Instagram
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </article>
        <article className={styles.article}>
          <div className={styles.container}>
            <div className={styles.row}>
              <div className={styles.col}>© {year}. All rights reserved.</div>
              <div className={styles.col}>
                <SiteLogo dark className={styles.logo} />
              </div>
              <div className={styles.col}>
                <LanguageSwitch className={styles.langauge} />
              </div>
            </div>
          </div>
        </article>
      </footer>
    );
  }
}
